import angular, { IWindowService } from 'angular';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { SharedAngular } from '@Client/@types/sharedAngular';

/**
 * @ngdoc type
 * @module flowingly.runner.login
 * @name runnerLoginController
 *
 * @description Controller for login page.
 */

angular
  .module('flowingly.runner.login')
  .controller('runnerLoginController', runnerLoginController);

runnerLoginController.$inject = [
  '$state',
  '$stateParams',
  'APP_CONFIG',
  'authService',
  'sessionService',
  '$window',
  'brandingService'
];

function runnerLoginController(
  $state: IStateService,
  $stateParams: IStateParamsService,
  APP_CONFIG: SharedAngular.APP_CONFIG,
  authService: AuthService,
  sessionService: SharedAngular.SessionService,
  $window: IWindowService,
  brandingService: SharedAngular.BrandingService
) {
  const ctrl = this;
  ctrl.authService = authService;

  ctrl.model = {
    email: undefined,
    password: undefined
  };

  init();

  function init() {
    if (
      !authService.isAuthenticated() ||
      !sessionService.getUser() ||
      $stateParams.forceRelogin
    ) {
      ctrl.errorMessage = undefined;

      // get pre-login settings. getLoginSettings return undefined when error so dont need catch block here
      sessionService
        .getLoginSettings($window.location.hostname)
        .then((loginSettings) => {
          APP_CONFIG.populateLoginSettings(loginSettings);
          login(APP_CONFIG);
        });
    } else {
      $window.location.pathname = '/flowsactive/';
    }
  }

  function login(settings: SharedAngular.APP_CONFIG) {
    const {
      welcomeText,
      loginAlertMessage,
      auth0UseUniversalLogin,
      logoUrl,
      favIcon,
      runnerTitle
    } = settings ?? {};

    const loginOptions = {
      welcomeText,
      loginAlertMessage,
      auth0UseUniversalLogin,
      logoUrl,
      favIcon,
      redirectUrl: $stateParams.redirectUrl,
      runnerTitle
    };

    authService.login(loginOptions);
  }
}
